// src/components/SessionPausedBanner.tsx
import React from 'react';
import { AlertCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function SessionPausedBanner (): React.ReactElement {
  const { t } = useTranslation();

  return (
    <div className="bg-amber-500/10 border border-amber-500/30 rounded-lg p-4 mb-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <AlertCircle className="h-5 w-5 text-amber-700 dark:text-amber-300" />
          <div>
            <h3 className="font-semibold text-amber-700 dark:text-amber-300">
              {t('wizard.dashboard.sessionPaused')}
            </h3>
            <p className="text-sm text-amber-700 dark:text-amber-300">
              {t('wizard.dashboard.pausedBanner')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}